function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "circle-check-primary",
  d: "M18.05 7.1L8.5 16.65 5.85 14c-.366-.366-.733-.366-1.1 0s-.366.733 0 1.1l3.15 3.15a.67.67 0 00.6.2c.2 0 .366-.066.5-.2l10.1-10.1c.134-.133.2-.3.2-.5s-.083-.383-.25-.55c-.333-.333-.666-.333-1 0zM12 0c3.333 0 6.167 1.167 8.5 3.5S24 8.667 24 12c0 3.3-1.167 6.134-3.5 8.5-2.333 2.333-5.167 3.5-8.5 3.5-3.3 0-6.134-1.167-8.5-3.5C1.167 18.134 0 15.3 0 12c0-3.333 1.167-6.167 3.5-8.5C5.866 1.167 8.7 0 12 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "circle-check-secondary",
  d: "M18.05 7.1c.334-.333.667-.333 1 0 .167.167.25.35.25.55 0 .2-.066.367-.2.5L9 18.25c-.134.134-.3.2-.5.2a.672.672 0 01-.6-.2L4.75 15.1c-.366-.366-.366-.733 0-1.1s.733-.366 1.1 0l2.65 2.65 9.55-9.55z"
});

var SvgIconCircleCheck = function SvgIconCircleCheck(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconCircleCheck;